/** @jsx jsx */

import { Fragment, ReactNode, KeyboardEvent } from 'react';

import { LabeledCheckbox } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Label from './Label';

export type Option = {
  checked: boolean;
  name: ReactNode;
  onKeyPress: (event: KeyboardEvent<HTMLLabelElement>) => void;
  value: string;
};

type Props = {
  description?: string;
  isRequired?: boolean;
  options: Option[];
  title: string;
};

function MultiSelectCheckboxes({
  description,
  isRequired,
  options,
  title,
}: Props) {
  return (
    <Fragment>
      {(title || description) && (
        <Label
          description={description}
          isRequired={isRequired}
          title={title}
        />
      )}
      {options.map(option => (
        <LabeledCheckbox
          aria-label={option.value}
          checked={option.checked}
          key={option.value}
          onChange={option.onKeyPress}
          tabIndex={0}
          value={option.value}
        >
          {option.name}
        </LabeledCheckbox>
      ))}
    </Fragment>
  );
}

export default MultiSelectCheckboxes;
